var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResumePhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91595 8.33316C4.36111 8.33821 1.66319 5.60796 1.667 2.08422C1.667 1.8541 1.85354 1.6665 2.08366 1.6665H3.1834C3.38988 1.6665 3.5653 1.81822 3.59562 2.02247C3.66829 2.512 3.81081 2.98857 4.01886 3.43763L4.06168 3.53005C4.12121 3.65855 4.08086 3.81123 3.96561 3.89353C3.62503 4.13675 3.49488 4.62632 3.7602 5.00832C4.09315 5.48769 4.51285 5.9073 4.99211 6.24009C5.37408 6.50534 5.86357 6.3752 6.10679 6.03469C6.18915 5.91938 6.34191 5.879 6.47049 5.93856L6.56248 5.98118C7.01157 6.18921 7.48818 6.33174 7.97775 6.4044C8.18201 6.43471 8.33366 6.61012 8.33366 6.81661V7.9165C8.33366 8.14661 8.14666 8.33316 7.91654 8.33316L7.91595 8.33316Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumePhoneIcon);
export default __webpack_public_path__ + "static/media/resume-phone-icon.122df3003d823df14828e3afc3a8d505.svg";
export { ForwardRef as ReactComponent };